import isEmpty from "lodash-es/isEmpty"
import isString from "lodash-es/isString"
import map from "lodash-es/map"

import type {
    IAttendanceSessionCohortDto,
    IAttendanceSessionCohortModel,
    ICohortAvailableTagDto,
    ICohortAvailableTagModel,
    ICohortBaseDto,
    ICohortBaseModel,
    IModuleBaseDto,
    IModuleBaseModel,
    TCohortModality
} from "@/3514/types"
import { ECohortModality } from "@/3514/types"

import { moduleBaseAdapter } from "./module.adapter"

function getCohortModalityEnumFromType(type: TCohortModality): ECohortModality {
    switch (type) {
        case "group":
            return ECohortModality.Group
        case "individual":
            return ECohortModality.Individual
        default:
            return null
    }
}

function cohortBaseAdapter(dto: ICohortBaseDto): ICohortBaseModel {
    return isEmpty(dto)
        ? null
        : {
              id: dto.id,
              journeyLength: dto.journey_length,
              modality: getCohortModalityEnumFromType(dto.modality),
              modules: isEmpty(dto.modules)
                  ? []
                  : map<IModuleBaseDto, IModuleBaseModel>(dto.modules, moduleBaseAdapter),
              name: dto.name
          }
}

function cohortAvailableTagAdapter(dto: ICohortAvailableTagDto): ICohortAvailableTagModel {
    return isEmpty(dto)
        ? null
        : {
              isFreeResponseAllowed: Boolean(dto.free_response),
              freeResponseValue: isString(dto.free_response) ? dto.free_response : null,
              id: dto.id,
              title: dto.title
          }
}

function attendanceSessionCohortAdapter(dto: IAttendanceSessionCohortDto): IAttendanceSessionCohortModel {
    return isEmpty(dto)
        ? null
        : {
              ...cohortBaseAdapter(dto),
              focusTags: isEmpty(dto.available_focus_tags)
                  ? []
                  : map<ICohortAvailableTagDto, ICohortAvailableTagModel>(
                        dto.available_focus_tags,
                        cohortAvailableTagAdapter
                    )
          }
}

export { getCohortModalityEnumFromType, attendanceSessionCohortAdapter, cohortAvailableTagAdapter }
